export type RowType = string | null;

export default (rows: RowType[][]): RowType[][] => {
    return rows.filter(row => {
        return row[2] !== null || row[3] !== null;
    });
};



// WEBPACK FOOTER //
// ./src/view/order/removeRowsWithoutOrder.ts